var map = {
	"./C1负二楼01后.mp4": 6139,
	"./C2 东侧门.mp4": 9005,
	"./C2 大堂南通道2.mp4": 9137,
	"./C东通道364.mp4": 4248,
	"./C栋负二层南通道.mp4": 7267,
	"./二期旋转楼梯.mp4": 4134,
	"./二期管理处仓库通道.mp4": 3686,
	"./二期管理处后门.mp4": 233,
	"./二期至一期通道407.mp4": 345,
	"./花园小路楼梯口.mp4": 9093
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5541;